import EmojiJS from "emoji-js";
import { flatten } from "lodash";

import { S3_BUCKETS } from "config";
import { S3Bucket } from "utils/s3_bucket";

type DataItem = {
  [key: number]: string;
};

const EmojiJSInstance = new EmojiJS();
const s3Bucket = new S3Bucket(S3_BUCKETS.EMOJIS);
EmojiJSInstance.img_sets.apple.path = s3Bucket.getS3Url();
EmojiJSInstance.allow_native = true;
EmojiJSInstance.include_title = true;
EmojiJSInstance.replace_mode = "img";
//  EmojiConverter.data is a dictionary of metadata that we will extract the values of
const dataValues: DataItem[] = Object.values((EmojiJSInstance as any).data);
//  Extract the list of aliases from the values
const aliasLists = dataValues.map((item) => item[3]);
// flatten into a single list
const aliases = flatten(aliasLists);
// sort and store into our EmojiConverter
(EmojiJSInstance as any).aliases = aliases.sort();

export const EmojiConverter = {
  aliases: aliases.sort(),
  replace_colons: EmojiJSInstance.replace_colons.bind(EmojiJSInstance),
};

export function getClosestCharPrecedingAt(text: string, char: string, position: number) {
  if (position > text.length) {
    return null;
  }
  // Search backward from the given position
  for (let i = position; i >= 0; i -= 1) {
    if (text[i] === char && (i === 0 || text[i - 1] === " ")) {
      return i;
    }
  }
  return null;
}
